import React from "react";
import { LocationWeather } from "../../data/mockLocations.js";

interface LocationCardProps {
  location: LocationWeather;
  className?: string;
}

const LocationCard: React.FC<LocationCardProps> = ({ location, className }) => {
  return (
    <a
      href="#"
      className={`location-card flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 ${className || ""}`}
    >
      <div className="flex items-center gap-3">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <i className="fas fa-city text-nearblack-100 text-sm"></i>
            <span className="font-semibold text-nearblack-500">
              {location.name}
            </span>
          </div>
          <span className="text-sm text-nearblack-100">
            {location.region}, {location.country}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <i
          className={`fas ${location.conditionIcon} text-xl text-meteoblue-500`}
          title={location.condition}
        ></i>
        <span className="text-xl font-semibold text-nearblack-500">
          {location.temperature}°C
        </span>
      </div>
    </a>
  );
};

export default LocationCard;
